import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo8/votopublico.png";
import Imagen2 from "../../../images/modulo8/votosecreto.png";
import Imagen3 from "../../../images/modulo8/votohombre.png";
import Imagen4 from "../../../images/modulo8/vototodos.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo8 } from "../../../routes/Module8";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo8/Actividad 6.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo8.content[0];
  const infoAct = modulo8.content[0].activities[5];
  const crumbs = [
    {
      title: modulo8.title,
      url: "/" + modulo8.url,
    },
    {
      title:
        modulo8.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo8.content[0].activities[6].name}`,
    linkNext: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[6].path}`,
    titlePrev: `${modulo8.content[0].activities[4].name}`,
    linkPrev: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo8.color,
    title: `${modulo8.title} - ${infoAct.name}`,
    name: modulo8.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo8.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-md-10 col-12 p-0">
          <ul className="mb-5">
            <li>
              Las elecciones en el Perú han pasado por muchos cambios. Observa
              las imágenes y encuentra las diferencias entre el voto de antes y
              el voto de hoy.
            </li>
            <li>
              Conversa sobre ellas con un compañero, compañera o familiar.
            </li>
          </ul>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-5 col-12">
          <div className="text-center">
            <h4>Antes</h4>
          </div>
          <img src={Imagen1} alt="voto" className="img-fluid" />
          <img src={Imagen3} alt="voto" className="img-fluid" />
        </div>
        <div className="col-md-5 col-12">
          <div className="text-center">
            <h4>Ahora</h4>
          </div>
          <img src={Imagen2} alt="voto" className="img-fluid" />
          <img src={Imagen4} alt="voto" className="img-fluid" />
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-lg-8 col-12 p-0">
          <ul>
            <li>Continúa conversando con tu compañero, compañera o familiar y responde las siguientes preguntas.</li>
          </ul>
          <div className="ms-3">
            <p>
              Recién a partir de una ley del año 1897 el voto en el Perú es
              secreto. ¿Qué les parece mejor, que el voto sea público o secreto?
              ¿Por qué?
            </p>
            <textarea className="form-control mb-4" rows={3} />
            <p>
              Las mujeres votaron por primera vez en las elecciones
              presidenciales de 1956. ¿Está bien que las mujeres no pudieran
              votar antes? ¿Por qué?
            </p>
            <textarea className="form-control mb-4" rows={3} />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y descríbanlas. Ayude a
          encontrar las diferencias. Hay que destacar en las elecciones de antes
          que el voto era público y que solo votaban los hombres. En las
          elecciones actuales el voto es secreto y votan hombres y mujeres.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
